import { ReactNode } from 'react'
import { Stack } from '@mui/material'

type TableItemsContainerProps = {
  children: ReactNode
}

export default function TableItemsContainer({
  children,
}: TableItemsContainerProps) {
  return (
    <Stack sx={{ py: 1.5, width: '100%' }} spacing={1.5}>
      {children}
    </Stack>
  )
}
